<div
  class="d-flex justify-content-center flex-column align-items-center"
  *ngIf="diet"
>
  <app-macros-list [macros]="diet.macros" [tracked]="true"></app-macros-list>

  <div class="d-flex flex-column mt-4">
    <div class="meal" *ngFor="let meal of diet.meals">
      <div class="d-flex justify-content-between">
        <span> {{ meal.title }}</span>

        <div
          *ngIf="meal.status == 'CHANGED_PORTION'"
          class="status"
          class="status"
          style="background-color: #525dc3"
        >
          Porción Cambiada
        </div>

        <div
          *ngIf="meal.status == 'INCOMPLETE'"
          class="status"
          class="status"
          style="background-color: #bfc352"
        >
          Porción Cambiada
        </div>

        <div
          *ngIf="meal.status == 'OUT_OF_DIET'"
          class="status"
          style="background-color: #c35252"
        >
          Fuera de dieta
        </div>

        <div
          *ngIf="meal.status == 'OUT_OF_DIET__NO_FOOD'"
          class="status"
          style="background-color: #c35252"
        >
          Comida desconocida
        </div>

        <div
          *ngIf="meal.status == 'NOT_COMPLETED'"
          class="status"
          style="background-color: #c5c5c5"
        >
          No completa
        </div>

        <div
          *ngIf="meal.status == 'SKIPED'"
          class="status"
          style="background-color: #c5c5c5"
        >
          Comida saltada
        </div>

        <div
          *ngIf="meal.status == 'COMPLETE'"
          class="status"
          style="background-color: #5fc353"
        >
          Completada
        </div>
      </div>

      <div class="d-flex flex-column">
        <div class="" *ngFor="let foodOption of meal.foodOptions">
          <div class="" *ngFor="let option of foodOption">
            <div
              class="food d-flex justify-content-between align-items-center"
              *ngIf="option.portionTracked !== 0"
            >
              <span>{{ option.food.name }}</span>

              <div class="">
                <span class="small-text me-2"
                  >{{ option.portionTracked }}

                  <span *ngIf="option.food.portionMeasure == 'UNIT'"
                    >unidad/es</span
                  >

                  <span
                    *ngIf="
                      option.food.portionMeasure == '100GR' ||
                      option.food.portionMeasure == 'GR'
                    "
                    >gr/s</span
                  >

                  <span *ngIf="option.food.portionMeasure == 'SPOON'"
                    >cucharada/as</span
                  >
                </span>

                <span class="small-text"
                  >{{ option.macros.selectedKcal }} kcal</span
                >
              </div>
            </div>
          </div>
        </div>

        <span *ngIf="meal.extraFood && meal.extraFood.length > 0"
          >Comidas Fuera de dieta</span
        >
        <div class="food" *ngFor="let extraFood of meal.extraFood">
          <span>{{ extraFood.food.name }}</span>

          <div class="">
            <span class="small-text me-2"
              >{{ extraFood.portion }}

              <span *ngIf="extraFood.food.portionMeasure == 'UNIT'"
                >unidad/es</span
              >

              <span
                *ngIf="
                  extraFood.food.portionMeasure == '100GR' ||
                  extraFood.food.portionMeasure == 'GR'
                "
                >gr/s</span
              >

              <span *ngIf="extraFood.food.portionMeasure == 'SPOON'"
                >cucharada/as</span
              >
            </span>

            <span
              class="small-text"
              *ngIf="extraFood.macros && extraFood.macros.kcal"
              >{{ extraFood.macros.selectedKcal }} kcal</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
